/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api';
export default {
  getConsultantInputSelect: function(config) {
    return apiCtrl.get('/admin/consultant/input-select', config);
  },
  getAllConsultants: function(config) {
    return apiCtrl.get('/admin/consultant/filtered/all', config);
  },
};
